// extracted by extract-css-chunks-webpack-plugin
module.exports = {"logo":"logo-2900MK0_","ad_1":"ad_1-3DbKzlvg","ad_2":"ad_2-3pvdH21m"};